import service from './api.services';

const obterGeometrias = async (idGeometrias) => {
    const response = await service.get(`api/geometria/obter/${idGeometrias}`);
    return response.data;
}

export {
    obterGeometrias
};
